module.exports = __webpack_public_path__ + "images/no_shadows-63205ad702d7778bd13860e8b8724ea1.jpg";